<template>
<div>
  <Banner
    title="CDE"
    pricing="true"
    level="4"
    bg-color="#fff"
    class="sticky-top"
    />
  
  
  
  <SectionDivider bg-color="#ffb300" />
  
  
  
  <Layout01 class="mt-5">
    <div slot="icon">
      <b-img
	:src="require('../assets/trinapp_cde.png')"
	class="mr-3"
	style="height: 114px;"
	/>
    </div>
    <div slot="header">
      <span class="red">TrinApp<sup>&trade;</sup> CDE</span>
    </div>
    <div slot="subtitle">
      Common Data Environment built on top of TrinPods with Trinity Conceptual AI.
    </div>
    <div slot="description">
      As Construction professionals ourselves, we think you should have 100% ownership and control over your construction data, files, drawings and specs; who has access to your data, where it is stored, and what apps you use to access it.
    </div>
  </Layout01>
  
  
  
  <b-container
    style="background-color: #ffb300;"
    fluid
    >
    <b-row class="text-light text-center px-lg-5 py-1">
      <b-col
	cols="12"
	md="6"
	lg="4"
	>
	<b-button size="lg" class="border-0 bg-transparent" @click="goto('obscure')">
	  <b-img :src="require('../assets/ocr_icon.png')" class="mr-1" style="height: 36px;" />
	  Find Obscure Documents
	</b-button>
      </b-col>
      <b-col
	cols="12"
	md="6"
	lg="4"
	>
	<b-button size="lg" class="border-0 bg-transparent" @click="goto('human')">
	  <b-img :src="require('../assets/trinity.png')" class="mr-1" style="height: 36px;" />
	  Human Approach
	</b-button>
      </b-col>
      <b-col
	cols="12"
	md="12"
	lg="4"
	>
	<b-button size="lg" class="border-0 bg-transparent" @click="goto('silo')">
	  <b-img :src="require('../assets/solid_logo_tr.png')" class="mr-1" style="height: 36px;" />
	  Connect Silos
	</b-button>
      </b-col>
    </b-row>
  </b-container>
  
  
  
  <div ref="obscure">
    <Layout02>
      <div slot="icon">
	<b-img :src="require('../assets/trinity_construction.png')" class="pt-5" style="width: 100px;" />
      </div>
      <div slot="header">
	Find Drawings &amp; Specs Much Faster
      </div>
      <div slot="description">
	<p class="mb-0">Conceptual AI Magic!</p>
	<p class="mb-0">Trinity will be working for you.</p>
	<p class="mb-5">Trinity's conceptual AI skills enable you to find your data, files, drawings and specs without you having to remember exact keywords.</p>
	<p class="mb-0">Then you can browse linked information using Trinity's One-World model.</p>
      </div>
      <div slot="button">
	<b-button size="lg" class="btn-orange my-5" href="https://trinpod.us/pricing?industry=construction">Get Started</b-button>
      </div>
    </Layout02>
  </div>



  <ImageWithButtonSection 
    sectionColorClass="bg-light"
    image="trinapp-cde.png"
    :figCaption="'TrinApp\u2122 CDE'" 
    industry="construction" 
  />
  
  
  
  <Layout03 checkColor="#ffb300">
    <div slot="header-top">
      "It's not right that a construction professional should have to think like a computer...
    </div>
    <div slot="bullet-1">Does your CDE create yet another data silo?</div>
    <div slot="bullet-2">Does your CDE hide files in folders?</div>
    <div slot="bullet-3">Do you have to tag files?</div>
    <div slot="bullet-4">Can it be frustrating to find the file you need?</div>
    <div slot="header-bottom">
      ...so we made the computer think like a construction professional"
    </div>
  </Layout03>
  
  
  
  <div ref="human" />
  <Layout04 checkColor="#ffb300">
    <div slot="subtitle">"We don't consider the norm of siloing data, hiding files, drawings, and specs inside a folder structure, a suitable solution for handling the volume, sharing needs, and dynamics  of construction projects."</div>
    <div slot="title"><span class="red">TrinApp<sup>&trade;</sup> CDE thinks like Construction Professionals do!</span></div>
    <div slot="bullet-1">TrinApp<sup>&trade;</sup> CDE conceptually links your data silos into your One-World model</div>
    <div slot="bullet-2">TrinApp<sup>&trade;</sup> CDE does NOT store files, drawings and specs in Folders!</div>
    <div slot="bullet-3">Manual Tagging is optional, Trinity automatically creates links for you.</div>
    <div slot="bullet-4">Finding files is impressively fast, with no need to remember folders or specific keywords.</div>
    <div slot="bullet-5">Files drawings and specs can be placed in multiple projects, sub projects and containers, wherever you like, without duplicating it, or later having two or more different copies of the same file.</div>
    <div slot="bullet-6">Ideas and information in data, files, drawings and specs change over time, so Trinity tracks every change to your information. *</div>
    <div slot="icon">
      <b-img
	:src="require('../assets/trinity_construction.gif')"
	class="pb-5"
	/>
    </div>
    <div slot="button">
      <b-button size="lg" class="btn btn-orange" href="https://trinpod.us/pricing?industry=construction">Get Started</b-button>
    </div>
  </Layout04>
  
  
  
  <div ref="silo" />
  <Layout05 checkColor="#ffb300">
    <div slot="header">
      <span class="red">Are your files, drawings and specs locked up into one application, by one external IT organization?</span>
    </div>
    <div slot="bullet-1">
      <p class="mb-0">Is it difficult to move your data, drawings and specs to another system?</p>
    </div>
    <div slot="bullet-2">
      <p class="mb-0">Are your data, drawings and specs siloed into one organization's system?</p>
    </div>
    <div slot="bullet-3">
      <p class="mb-0">Does an external IT company own your data, drawings and specs and possibly harvest the data from you for their own benefit?</p>
    </div>
    <div slot="top-right-icon">
      <b-img :src="require('../assets/trinapp_cde.png')" style="height: 82px;" />
    </div>
    <div slot="description">
      <h2 class="mb-5">We think your company should have 100% ownership and control over their data, files, drawings and specs;</h2>
      <h2>who has access to your information, where it is stored, and what apps are used to access it. </h2>
    </div>
  </Layout05>
  
  


  <SectionDivider bg-color="#ffb300" />



  <Layout06 checkColor="#ffb300">
    <div slot="icon">
      <b-img :src="require('../assets/trinpod_secure.png')" style="width: 220px;" />
    </div>
    <div slot="blurb">
      <p><span style="color: #585aff;">Graph</span><span style="color: #ff1d1d;">metrix</span> has its roots in the construction industry where massive amounts of data, tens of thousands of documents and files from multiple vendors have to be stored, managed, related, shared, and found, all with strict security.</p>
    </div>
    <div slot="description">
      <p class="mb-5">When you use TrinApp-CDE or any other of our TrinApps, it stores all the data and files in the TrinPod you control, whether hosted by us or by your own company.</p>
      <p class="mb-5">Now your files and data can be accessed by any Solid app created by us or any other Solid app developer.</p>
      <p class="mb-5">And if you want to move your files and data, you can move it to any other Solid Pod provider.</p>
      <p class="mb-5">This is a massive improvement to your ownership, control & privacy.</p>
    </div>
    <div slot="buttons">
      <div class="pt-5 pb-1">	
	<b-button
	  size="lg"
	  class="btn-yellow"
	  style="width: 200px;"
	  to="/construction/trinpod"
	  @click.native="scrollToTop()"
	  >
	  TrinPod
	</b-button>
      </div>
      <div class="pb-5">
	<b-button
	  size="lg"
	  class="btn-orange"
	  href="https://trinpod.us/pricing?industry=construction"
	  >
	  Get Started
	</b-button>      
      </div>
    </div>
  </Layout06>



  <SectionDivider bg-color="#ffb300" />



  <Layout07 checkColor="#ffb300">
    <div slot="icon">
      <b-img :src="require('../assets/trinapp_cde.png')" style="height: 114px;" />
    </div>
    <div slot="header">
      <span class="red">Simple steps to get started</span>
    </div>
    <div slot="list">
      <ol>
	<li>Get Started with TrinApp<sup>&trade;</sup> CDE and a TrinPod<sup>&trade;</sup></li>
	<li>Upload Some Files, Construction Drawings, and Specs</li>
      </ol>
    </div>
    <div slot="description">
      <p class="mb-0">You are done.</p> 
      <p class="mb-0">Trinity will place your information into the One-World model where she can do her magic to help you.</p>
      <p class="mb-0">You can get your work done faster by seeing new relationships and finding your files with ease.</p>
      <p class="mb-0">You can securely collaborate globally with other construction professionals.</p>
    </div>
  </Layout07>



  <Layout08 bg-color="#ffb300">
    <div slot="header">Ready to instantly find your files?</div>
    <div slot="buttons">
      <b-button size="lg" class="btn-outline-light text-light px-5 mx-auto mr-sm-4 mb-2" href="https://forms.zohopublic.com/graphmetrix/form/ContactUs/formperma/4OMSwRrUmWo7aROfkChl9K7AVaPZWcvTwMOOtA41I6s" target="_blank">Contact Us</b-button>
	<b-button size="lg" class="btn-orange mb-2"  href="https://trinpod.us/pricing?industry=construction">Get Started</b-button>
    </div>
  </Layout08>
  


  <GmxFooter />  
</div>
</template>

<script>
import GmxFooter from '@/components/footer.vue';
import Banner from '@/components/gmx-banner.vue';
import SectionDivider from '@/components/section-divider.vue';
import Layout01 from '@/components/layout-01.vue';
import Layout02 from '@/components/layout-02.vue';
import Layout03 from '@/components/layout-03.vue';
import Layout04 from '@/components/layout-04.vue';
import Layout05 from '@/components/layout-05.vue';
import Layout06 from '@/components/layout-06.vue';
import Layout07 from '@/components/layout-07.vue';
import Layout08 from '@/components/layout-08.vue';
import ImageWithButtonSection from '@/components/image-with-button-section.vue';
export default {
    name: "ConstructionCDE",
    components: {
	Banner,
	GmxFooter,
	SectionDivider,
	Layout01,
	Layout02,
	Layout03,
	Layout04,
	Layout05,
	Layout06,
	Layout07,
	Layout08,
  ImageWithButtonSection
    },
    mounted () {
	window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy () {
	window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
	img: function (image) {
	    require(image)
	},
	onScroll: function () {
	    // Get the current scroll position
	    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
	    if (currentScrollPosition < 0) {
		return
	    }
	    // Stop executing this function if the difference between
	    // current scroll position and last scroll position is less than some offset
	    if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
		return
	    }
	    this.showVerticalRight = currentScrollPosition < this.lastScrollPosition
	    this.showNavbarLogo = currentScrollPosition > this.lastScrollPosition
	    this.lastScrollPosition = currentScrollPosition
	},
	goto: function (refName) {
    	    var element = this.$refs[refName];
	    //log.debug(element);
	    var top = element.offsetTop;
      
	    window.scrollTo(0, top);
	},
	scrollToTop: function () {
	    window.scrollTo(0,0);
        }
    }
}
</script>

